import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import {styleMap} from 'lit/directives/style-map.js';
import {when} from 'lit/directives/when.js';
import {connect} from 'pwa-helpers';
import store from '../store';



@customElement('progress-bar')
export class ProgressBar extends connect(store)(LitElement) {

	static styles = [
		css`
		  :host{
		  	height: var(--height-widget);
			display: flex;
			justify-content: space-around;
			flex-direction: column;
		  }
		.progressbar {
			height: 10px;
			position: relative;
			background: transparent;
			border: 1px solid var(--color-white);
			border-radius: 0px;
			padding: 0px;
			box-shadow: none;
			width: 100px;
		  }
		  .progressbar > span {
			display: block;
			height: 100%;
			border-radius: 0px;
			background-color: var(--color-white);
			position: relative;
			overflow: hidden;
		  }
		`
	];

	@property({type: Number})
	progress = 0;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	render() {
		const s = this.state;
		return html`

		<div class="progressbar">
			<span style="${styleMap({width: this.progress + '%'})}"></span>
		</div>

		`;
	}
}
